let region: string | undefined;

export function setProductRegion(env: string | undefined) {
    region = env;
}

export function getProductRegion(): string | undefined {
    return region;
}
